import { Action, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductTourActivity, ServiceProvider } from 'features/entities/entitiesTypes';
import { fetchDashboardDataSuccess } from 'features/entities/entitiesSlice';
import { ErrorPayload } from 'common/types';

export type ProductTourState = {
  shouldDisplayProductTour: boolean;
  productTourVersion?: string;
  serviceToOpenOnHide?: ServiceProvider;
};
const initialState: ProductTourState = {
  shouldDisplayProductTour: false,
};

export const productTour = createSlice({
  name: 'productTour',
  initialState,
  reducers: {
    displayProductTour: (state) => {
      state.shouldDisplayProductTour = true;
    },
    hideProductTour: (state) => {
      state.shouldDisplayProductTour = false;
    },
    updateProductTourViewedStart: (state, action: PayloadAction<ProductTourActivity>) => {},
    updateProductTourViewedSuccess: (state, action: Action) => {},
    // we ignore errors that happen when we try to save the product tour viewed state
    updateProductTourViewedFailure: (state, action: PayloadAction<ErrorPayload>) => {},
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDashboardDataSuccess, (state, action) => {
      state.productTourVersion = action.payload.productTourVersion;
    });
  },
});

export const {
  displayProductTour,
  hideProductTour,
  updateProductTourViewedFailure,
  updateProductTourViewedStart,
  updateProductTourViewedSuccess,
} = productTour.actions;

export const productTourReducer = productTour.reducer;

export { initialState as productTourInitialState };
